// extracted by mini-css-extract-plugin
export default {"sectionContainer":"controversies_sectionContainer__cTap2","controversie":"controversies_controversie__UUKfG","notInformed":"controversies_notInformed__IiRwU"};